// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight___Prrf","containerItemsCenter":"Skeleton_containerItemsCenter__O_OfI"};